module.exports = __webpack_public_path__ + "img/image_2022_07_25T09_11_25_242Z.b81d8feb.png";